import { datadogLogs } from '@datadog/browser-logs';

export default {
  info: (message: string) => datadogLogs.logger.info(message),
};
